module.exports = __webpack_public_path__ + "static/media/headerImage.bb061940.png";